<!-- Top Bar: Use PrimeNG Toolbar for a styled top bar with a button -->
<p-toolbar class="dashboard-toolbar" styleClass="margin-bottom: 2rem; border-bottom: 2px solid #0ea5e9;">
    <ng-template pTemplate="left">
        <div style="width: 100%; display: flex; justify-content: center;">
            <h1 style="font-size: 2.5rem; margin: 0;">
                Performance Panel
            </h1>
        </div>
    </ng-template>
    <ng-template pTemplate="right">
        <button
            pButton
            type="button"
            label="Go to Orders"
            icon="pi pi-list"
            style="min-width: 180px; font-size: 1rem;"
            (click)="goToOrderHeader()"
        ></button>
    </ng-template>
</p-toolbar>
 
<!-- Add extra margin below toolbar for spacing -->
<div style="height: 1rem;"></div>
 
<p-card header="Sales Report Overview" styleClass="sales-overview-card">
  <div class="metrics-grid">
    <div class="metric-card gross-sales">
      <div class="metric-icon">
        <i class="pi pi-bullseye"></i>
      </div>
      <div class="metric-content">
        <h3>{{ target | currency:'EUR':'symbol' }}</h3>
        <p>Target</p>
      </div>
    </div>
 
    <div class="metric-card average-sales">
      <div class="metric-icon">
        <i class="pi pi-trophy"></i>
      </div>
      <div class="metric-content">
        <h3>{{ achievement | currency:'EUR':'symbol' }}</h3>
        <p>Achievement</p>
      </div>
    </div>
     <div class="metric-card progress-box">
  <div class="metric-icon">
    <i class="pi pi-chart-line"></i>
  </div>
  <div class="metric-content">
    <h3>{{ progress }}%</h3>
    <p>Progress</p>
  </div>
</div>
 
    <div class="metric-card sales-persons">
      <div class="metric-icon">
        <i class="pi pi-list"></i>
      </div>
      <div class="metric-content">
        <h3>{{ ordersPunched }}</h3>
        <p>Total Orders</p>
      </div>
    </div>
 
 
  </div>
<h5 *ngIf="message" style="text-align: center; margin-top: 1rem; color: #f5b163;">
    <i class="pi pi-exclamation-triangle" style="margin-right: 0.5rem;"></i>{{ message }}
</h5>
  <!-- <div class="sales-table-container">
    <p-table [value]="salesData" [paginator]="true" [rows]="10"
             [showCurrentPageReport]="true" responsiveLayout="scroll"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
      <ng-template pTemplate="header">
        <tr>
          <th>Sales Person</th>
          <th>Order Line Amount</th>
          <th>Performance</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-sale>
        <tr>
          <td style="text-align:center; vertical-align:middle;">{{ sale.firstName }} {{ sale.lastName }}</td>
          <td style="text-align:center; vertical-align:middle;">{{ sale.orderLineAmount | currency }}</td>
          <td style="text-align:center; vertical-align:middle;">
            <div class="performance-bar-container">
              <p-progressBar
                [value]="getPerformancePercent(sale)"
                [showValue]="true"
                unit="%"
                [style]="{ width: '100%', minWidth: '120px', maxWidth: '250px', height: '24px', padding: 0 }"
                [styleClass]="'performance-bar'"
              ></p-progressBar>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div> -->
</p-card>
<p-card styleClass="mb-3">
    <ng-template pTemplate="header">
        <span class="pi pi-calendar" style="margin-right: 0.5rem;"></span>
        <span style="font-weight: 500;">Choose Date Range</span>
    </ng-template>
<div class="dashboard-date-filter" style="display: flex; gap: 1rem; align-items: center; margin-bottom: 0;">
    <span>From:</span>
    <input
        id="fromDate"
        pInputText
        [(ngModel)]="fromDate"
        name="fromDate"
        type="date"
        class="p-inputtext p-component"
        style="width: 160px;"
        (change)="onDateChange()"
        [max]="toDate"
        required
    />
    <span>to</span>
    <input
        id="toDate"
        pInputText
        [(ngModel)]="toDate"
        name="toDate"
        type="date"
        class="p-inputtext p-component"
        style="width: 160px;"
        (change)="onDateChange()"
        [min]="fromDate"
        [max]="todayDate"
        required
    />
</div>
</p-card>
<app-moving-items-section [fastMovingItems]="fastMovingItems" [slowMovingItems]="slowMovingItems"></app-moving-items-section>
  <!-- <div class="col-12">
      <app-moving-items-section
        [fastMovingItems]="fastMovingItems"
        [slowMovingItems]="slowMovingItems"
        [errorMsg]="errorMsg">
      </app-moving-items-section>
    </div> -->
<style>
.dashboard-sections {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  margin-top: 2rem;
}
.dashboard-section-left {
  flex: 1 1 0;
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
 
 